// extracted by mini-css-extract-plugin
export default {"form":"QuestionForm_form__Nh+83","input":"QuestionForm_input__I4aK0","button":"QuestionForm_button__am9fX"};